import { render } from "./DateOrTimeField.vue?vue&type=template&id=b519fec4&scoped=true"
import script from "./DateOrTimeField.vue?vue&type=script&lang=ts"
export * from "./DateOrTimeField.vue?vue&type=script&lang=ts"

import "./DateOrTimeField.vue?vue&type=style&index=0&id=b519fec4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-b519fec4"

export default script